import React from 'react';
import { TldOfferExpand } from '../expand/TldOfferExpand';
import { TldOfferWidgetModule } from '../tldOfferWidget.module';
import { bmLayout } from './bm.layout';
export const BmExpand = _ref => {
  let domain = _ref.domain;
  return /*#__PURE__*/React.createElement(TldOfferWidgetModule.Provider, {
    Layouts: {
      customConfiguration: bmLayout
    }
  }, /*#__PURE__*/React.createElement(TldOfferExpand, {
    key: domain,
    domain: domain
  }));
};
//# sourceMappingURL=BmExpand.js.map